import { produce } from 'immer';
import { collabActionTypes } from './collab.types';

const initialState = {
    currentRoom: null,                          // diagramId of the joined room
    role: null,                                 // 'view' | 'comment' | 'edit' | 'admin' | 'owner' | null
    lastUnauthorizedReason: null,               // 'no_membership' | 'role_view_only' | 'malformed' | 'apply_failed' | null
};

const collabReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case collabActionTypes.COLLAB_ROOM_JOINED: {
                draft.currentRoom = action.payload.diagramId;
                draft.role = action.payload.role;
                draft.lastUnauthorizedReason = null;
                break;
            }
            case collabActionTypes.COLLAB_ROOM_LEFT:
            case collabActionTypes.COLLAB_RESET: {
                draft.currentRoom = null;
                draft.role = null;
                draft.lastUnauthorizedReason = null;
                break;
            }
            case collabActionTypes.COLLAB_JOIN_FAILED: {
                draft.currentRoom = null;
                draft.role = null;
                break;
            }
            case collabActionTypes.COLLAB_DOC_UNAUTHORIZED: {
                draft.lastUnauthorizedReason = action.payload.reason || null;
                break;
            }
            default:
                break;
        }
    });

export default collabReducer;
